<script lang="ts">
export default {
  inheritAttrs: false,
};
</script>
<script lang="ts" setup>
import type {
  Area,
  FocalPointAsset,
  FromResolver,
} from "#magnolia-layer/types/magnolia-types";
import type {AspectRatio} from "#base-layer/utils/parseAspectRatio";
import type {LinkTypes} from "#magnolia-layer/types/api";

const props = defineProps<{
  metadata: Area;
  title: string;
  text?: string;
  category?: string;
  link?: LinkTypes;
  image: FromResolver<FocalPointAsset>;
  aspectRatio: "original" | AspectRatio;
}>();

const aspectRatioFallback = props.aspectRatio ?? "original";
const parsedRatio =
  aspectRatioFallback === "original"
    ? undefined
    : parseAspectRatio(aspectRatioFallback);
const extract =
  parsedRatio === undefined
    ? undefined
    : imageToExtractionArea(props.image, parsedRatio);

const resolvedLink = props.link ? resolveLink(props) : undefined;
</script>

<template>
  <TextMediaLayout
    :category="category"
    :compact="false"
    :link="resolvedLink"
    :title="title">
    <template #media>
      <MagnoliaPicture
        :asset="image"
        :modifiers="{extract}"
        loading="lazy"
        sizes="400 md:600 lg:520 xl:640">
      </MagnoliaPicture>
    </template>
    <div v-if="text" v-html="text"></div>
  </TextMediaLayout>
</template>

<style lang="scss" scoped></style>
